export default {
  certification: `profile/certification`,
  update: `profile/certification/update`,
  remove: `profile/certification/remove`,
  storesubjects: `profile/certification/storesubjects`,
  certificationAttachment: (query) =>
    `profile/certification/attachment/getCertificationAttachment?${preparequery(
      query
    )}`,
};

function preparequery(obj) {
  let queryString = ``;
  for (const [key, value] of Object.entries(obj)) {
    queryString += `${key}=${value}&`;
  }
  return queryString;
}
